<!--
 * @Author: Gaho
 * @Date: 2024-03-01 11:42:44
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 17:12:03
 * @Description: 
-->
<template>
    <div class="rule-paylines">
        <p class="paylines-text">{{ $t('corgiwildPaylinesRule') }}</p>
        <q-img src="@/assets/imgs/casino/corgiwild/combination.webp" alt="" class="paylines-img" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: 'dialogPaylines',
    data(){
        return {
            $t: useI18n().t
        }
    }
})
</script>
<style lang="scss" scoped>
.rule-paylines {
    margin-top: 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .paylines-text {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        margin: 0 auto 12px;
        max-width: 216px;
    }
    .paylines-img {
        margin-bottom: 42px;
        width: 216px;
    }
}
</style>